module.exports = __webpack_public_path__ + "img/2020_07_30_08_46.c1987bc3.jpg";